<template>
  <main class="main page-inside payment-result-page">
    <div class="section payment-section">
      <div class="page-inside-top">
        <div class="wrapper">
          <div class="title big">{{$t('processing_payment')}}</div>
          <div class="desc" style="margin-top: 16px;">{{$t('please_wait_while_we_process')}}</div>
          <div v-if="error" class="desc red" style="margin-top: 24px;">{{ error }}</div>
          <div v-if="status === 'success'">
            <div class="desc green" style="margin-top: 24px;">{{$t('payment_successful_redirecting')}}</div>
          </div>
          <div v-if="status === 'fail'">
            <div class="desc red" style="margin-top: 24px;">{{$t('payment_failed_redirecting')}}</div>
          </div>
          <div v-if="status === 'processing'">
            <div class="loader" style="margin: 32px auto;"></div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '../axios';

export default {
  name: 'ProcessingPaymentPage',
  data() {
    return {
      status: 'processing',
      error: null,
      pollInterval: null,
    };
  },
  mounted() {
    const orderId = this.$route.query.order_id;
    if (!orderId) {
      this.error = 'Order ID is missing.';
      return;
    }
    this.pollStatus(orderId);
    this.pollInterval = setInterval(() => this.pollStatus(orderId), 3000);
  },
  beforeUnmount() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  },
  methods: {
    async pollStatus(orderId) {
      if (this.timedOut) return;
      try {
        const res = await axios.get(`/orders/status`, { params: { order_id: orderId } });
        if (res.data && res.data.order && res.data.order.redirect_url) {
          clearInterval(this.pollInterval);
          if (this.timeoutHandle) clearTimeout(this.timeoutHandle);
          window.location.href = res.data.order.redirect_url;
          return;
        }
        // Handle numeric status codes from backend
        const orderStatus = res.data.order && res.data.order.status;
        // Map backend status codes to frontend status
        if (orderStatus === 2 || orderStatus === 3) { // accepted or completed
          this.status = 'success';
          clearInterval(this.pollInterval);
          if (this.timeoutHandle) clearTimeout(this.timeoutHandle);
          setTimeout(() => this.$router.replace({ name: 'PaymentSuccessPage', query: { order_id: orderId } }), 1500);
        } else if (orderStatus === 4 || orderStatus === 5 || orderStatus === 6 || orderStatus === 7) { // denied, deleted, client refused, payment error
          this.status = 'fail';
          clearInterval(this.pollInterval);
          if (this.timeoutHandle) clearTimeout(this.timeoutHandle);
          setTimeout(() => this.$router.replace({ name: 'PaymentFaliPage', query: { order_id: orderId } }), 1500);
        } else {
          this.status = 'processing';
        }
      } catch (e) {
        this.error = 'Could not check payment status.';
      }
    }
  }
};
</script>

<style scoped>
.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #19D6CC;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
